import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import "./custom.scss";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@mdi/font/css/materialdesignicons.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueRouter from "vue-router";
import routes from "./router/routes";
import vmodal from "vue-js-modal";
import VCalendar from "v-calendar";

Vue.use(vmodal);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.component("multiselect", Multiselect);
Vue.use(VCalendar, {
  componentPrefix: "vc"
});
const router = new VueRouter({
  routes
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router: router
}).$mount("#app");
